import { ChangeDetectorRef, ElementRef } from '@angular/core';
import { MicroApp, AppHost } from 'lib-host-interface';
import { OrgClass } from '../models/orgclass';
import { ApphostService } from '../services/app-host.service';
import { ErrorType } from '../components/tess-error/tess-error.component';
import { LoggingService } from '../services/logging.service';

export class TessContext extends MicroApp {
  loading = false;
  showError = false;
  errorType: ErrorType = 'DEFAULT';
  orgClass: OrgClass;

  constructor(
    appHost: AppHost,
    changeDetectorRef: ChangeDetectorRef,
    elementRef: ElementRef,
    public appHostService: ApphostService,
    public loggingService?: LoggingService,
  ) {
    super(appHost, changeDetectorRef, elementRef);
  }

  public initiateTessApp = async () => {
    this.loading = true;
    this.loggingService?.log('Loading Tess Context');
    try {
      await this.appHost.next();
      this.appHostService.appHost = this.appHost;
      await this.appHostService.setUserContext();
      this.loading = false;
    } catch (error) {
      this.loading = false;
      this.showError = true;
      this.changeDetectorRef.detectChanges();
    }

    const orgClass = this.appHostService.orgClass;

    if (orgClass === 'INVALID') {
      this.loading = false;
      this.errorType = 'FORBIDDEN';
      this.showError = true;
      this.changeDetectorRef.detectChanges();
      return;
    }
    this.orgClass = orgClass;
  };
}
